'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dropdown = require('./dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _dropdownButton = require('./dropdown-button');

var _dropdownButton2 = _interopRequireDefault(_dropdownButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dropdown2["default"].Button = _dropdownButton2["default"];
exports["default"] = _dropdown2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/dropdown/index.js
// module id = 129
// module chunks = 0